const accountType = {
  CHECKING_ACCOUNT: 'CACC',
  SALARY_ACCOUNT: 'SLRY',
  SAVINGS_ACCOUNT: 'SVGS'
};

module.exports = accountType;
